import styled from "styled-components";

export const SOnboardingFormInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 416px;
`;
